import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

function ProtectedRoute({ children, adminOnly }) {
  const [status, setStatus] = useState('checking'); // checking | valid | invalid

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setStatus('invalid'); return; }
    if (adminOnly) {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user?.role !== 'admin') { setStatus('invalid'); return; }
    }
    // Server-side verify zodat verlopen/ingetrokken tokens direct redirecten
    let cancelled = false;
    axios.get(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
        if (cancelled) return;
        if (adminOnly && res.data?.role !== 'admin') {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setStatus('invalid');
        } else {
          setStatus('valid');
        }
      })
      .catch(() => {
        if (cancelled) return;
        // Token verlopen / ongeldig / user verwijderd → opruimen + redirect
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setStatus('invalid');
      });
    return () => { cancelled = true; };
  }, [adminOnly]);

  if (status === 'checking') {
    return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Toegang controleren…</div>;
  }
  if (status === 'invalid') return <Navigate to="/login" replace />;
  return children;
}

export default ProtectedRoute;
